import type { TutLevelKey } from './tut-types';

export const TUT_LEVEL_COLORS: Record<
  TutLevelKey | 'all',
  { primary: string; secondary: string; accent: string }
> = {
  all: {
    primary: '#FF8A00',
    secondary: '#FFE57F',
    accent: '#5E35B1',
  },
  basic: {
    primary: '#00BCD4',
    secondary: '#ff9e4e',
    accent: '#ff4163',
  },
  beginning: {
    // primary: '#5C94FF',
    primary: '#2196F3',
    secondary: '#FF8A00',
    accent: '#FF8A00',
  },
  intermediate: {
    primary: '#009688',
    secondary: '#FF8A00',
    accent: '#FF8A00',
  },
  advanced: {
    primary: '#7E57C2',
    secondary: '#FF8A00', // #32b053
    accent: '#FF8A00',
  },
};
